import { ChainId } from '@shared/utils/config/networks';
import { deepConvertBigInt } from '@shared/utils/off-chain/deep-convert-bigint';
import { getUrls } from '@shared/utils/config/environment';
import { executeSuiTransaction } from '@shared/utils/sui/executeSuiTransaction';
import { createDBTransferReceipt } from '@/lib/db/DBTransferHistoryHelpers';
import { createDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
import { createTDBOrder } from '@/lib/db/DBOrderHelpers';
import { signSuiTransaction } from '../signOrder/signSui';
export default async function executeViaClientSui({
  params,
  pkp,
  orderType,
  dbOrderParams,
  suiKeyPair,
  existingdbOrder,
  transferParams
}) {
  var _a, _b, _c, _d, _e;
  try {
    const startTime = new Date().getTime();
    const tokenPrices = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.tokenPrices;
    const toAssetPriceData = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.toAssetPriceData;
    const dbOrderType = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.dbOrderType;
    // Create or use existing DB order
    const dbOrder = existingdbOrder !== null && existingdbOrder !== void 0 ? existingdbOrder : (await createTDBOrder({
      cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
      order: params,
      pkp,
      token_prices: tokenPrices,
      order_type: dbOrderType,
      pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
    })).data;
    console.log('executing order Sui, created database order entry', dbOrder);
    // Get transaction from params
    const transaction = ((_b = (_a = params === null || params === void 0 ? void 0 : params.transactions) === null || _a === void 0 ? void 0 : _a.swap) === null || _b === void 0 ? void 0 : _b[0]) || ((_d = (_c = params === null || params === void 0 ? void 0 : params.transactions) === null || _c === void 0 ? void 0 : _c.transfer) === null || _d === void 0 ? void 0 : _d[0]);
    if (!transaction) {
      throw new Error('No transaction found in params');
    }
    // Sign transaction
    const isSponsored = !!params.orchestratorPKP;
    const signedTx = await signSuiTransaction({
      transaction,
      signer: suiKeyPair
    });
    // If this is a sponsored transaction, we return early with the signed transaction
    // The orchestrator will handle getting the sponsor signature and execution
    if (isSponsored) {
      return {
        status: 'pending_sponsor',
        signedTx,
        dbOrder,
        time: new Date().getTime() - startTime
      };
    }
    // Execute transaction
    const txBlock = signedTx.transactionBlock;
    const signatures = signedTx.signature;
    const executionResponse = await executeSuiTransaction({
      transactionBlock: txBlock,
      signatures: [signatures]
    });
    // Format response
    const decodedResponse = {
      type: orderType,
      status: executionResponse.status,
      error: executionResponse.error,
      note: 'Client side execution',
      quoteId: params.quoteId,
      quote: params,
      transferTransaction: (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? {
        network: ChainId.SUI,
        hash: executionResponse.txHash,
        status: executionResponse.status,
        explorerUrl: executionResponse.explorerUrl
      } : null,
      suiTransaction: !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? {
        hash: executionResponse.txHash,
        network: ChainId.SUI,
        status: executionResponse.status,
        explorerUrl: executionResponse.explorerUrl
      } : null
    };
    const executionTime = new Date().getTime() - startTime;
    // Handle DB updates
    let dbOrderHistory;
    if (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) {
      // Handle withdrawal DB update
      dbOrderHistory = await createDBTransferReceipt({
        from_address: transferParams.from_address,
        to_address: transferParams.to_address,
        decimals: transferParams.decimals,
        token_address: transferParams.token_address,
        token_amount: transferParams.token_amount.toString(),
        token_amount_formatted: transferParams.token_amount_formatted,
        usd_value: transferParams.usd_value.toString(),
        type: 'withdraw',
        chain_id: transferParams.network,
        txn: executionResponse.txHash,
        token_metadata: JSON.stringify(deepConvertBigInt({
          symbol: transferParams.token_symbol,
          name: transferParams.token_name,
          image_thumb_url: transferParams.token_logo_url
        })),
        result: JSON.stringify(deepConvertBigInt({
          decodedResponse,
          executionTime
        }))
      });
    } else {
      // Handle swap DB update
      dbOrderHistory = (await createDBOrderHistory(deepConvertBigInt({
        order_id: dbOrder.id,
        cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
        status: executionResponse.status,
        result: {
          decodedResponse,
          executionTime
        },
        token_prices: tokenPrices,
        orchestrator_pkp: params === null || params === void 0 ? void 0 : params.orchestratorPKP,
        token_out_prices: toAssetPriceData,
        execution_time: executionTime,
        pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
      }))).data;
    }
    // Update order if successful
    if (executionResponse.status === 'success' && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))) {
      try {
        const executorUrl = ((_e = getUrls()) === null || _e === void 0 ? void 0 : _e.EXECUTOR_URL) || 'https://staging-api.tradegenius.com';
        const updateUrl = `/api/forwardGet?target=${executorUrl}/api/order/update-user-order?order_id=${dbOrder.id}&cloud_wallet=${pkp === null || pkp === void 0 ? void 0 : pkp.suiAddress}`;
        fetch(updateUrl);
      } catch (e) {
        console.log('Error updating order:', e);
      }
    }
    return {
      result: {
        message: `${orderType} client execution complete`,
        decodedResponse,
        executionTime,
        status: executionResponse.status
      },
      dbOrderHistory,
      dbOrder,
      time: executionTime
    };
  } catch (error) {
    console.error('Error in executeViaClientSui:', error);
    throw error;
  }
}